export enum OperationsConstants {
  SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT = 'operations/SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT',
  SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT_PNNV = 'operations/SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT_PNNV',
  SET_STRETCHER_CHAIR_MOVING_TO = 'operations/SET_STRETCHER_CHAIR_MOVING_TO',
  SET_JOINT_COMMISSION_TIME_OUT = 'operations/SET_JOINT_COMMISSION_TIME_OUT',
  SET_RIGHT_PATIENT = 'operations/SET_RIGHT_PATIENT',
  SET_RIGHT_PROCEDURE = 'operations/SET_RIGHT_PROCEDURE',
  SET_RIGHT_CONSENT = 'operations/SET_RIGHT_CONSENT',
  SAVE_RIGHT_CONSENT = 'operations/SAVE_RIGHT_CONSENT',
  DELETE_RIGHT_CONSENT = 'operations/DELETE_RIGHT_CONSENT',
  GET_RIGHT_SITE_SIDE = 'operations/GET_RIGHT_SITE_SIDE',
  SET_RIGHT_SITE_SIDE = 'operations/SET_RIGHT_SITE_SIDE',
  SAVE_RIGHT_SITE_SIDE = 'operations/SAVE_RIGHT_SITE_SIDE',
  DELETE_RIGHT_SITE_SIDE = 'operations/DELETE_RIGHT_SITE_SIDE',
  GET_RIGHT_POSITION = 'operations/GET_RIGHT_POSITION',
  SET_RIGHT_POSITION = 'operations/SET_RIGHT_POSITION',
  SAVE_RIGHT_POSITION = 'operations/SAVE_RIGHT_POSITION',
  DELETE_RIGHT_POSITION = 'operations/DELETE_RIGHT_POSITION',
  GET_COMPLETE = 'operations/GET_COMPLETE',
  SET_COMPLETE = 'operations/SET_COMPLETE',
  SAVE_COMPLETE = 'operations/SAVE_COMPLETE',
  DELETE_COMPLETE = 'operations/DELETE_COMPLETE',
  GET_SAFETY_BRIEF = 'operations/GET_SAFETY_BRIEF',
  SET_SAFETY_BRIEF = 'operations/SET_SAFETY_BRIEF',
  SAVE_SAFETY_BRIEF = 'operations/SAVE_SAFETY_BRIEF',
  DELETE_SAFETY_BRIEF = 'operations/DELETE_SAFETY_BRIEF',
  GET_LAST_NAME = 'operations/GET_LAST_NAME',
  SET_LAST_NAME = 'operations/SET_LAST_NAME',
  SAVE_LAST_NAME = 'operations/SAVE_LAST_NAME',
  DELETE_LAST_NAME = 'operations/DELETE_LAST_NAME',
  GET_FIRST_NAME = 'operations/GET_FIRST_NAME',
  SET_FIRST_NAME = 'operations/SET_FIRST_NAME',
  SAVE_FIRST_NAME = 'operations/SAVE_FIRST_NAME',
  DELETE_FIRST_NAME = 'operations/DELETE_FIRST_NAME',
  GET_WEIGHT = 'operations/GET_WEIGHT',
  SET_WEIGHT = 'operations/SET_WEIGHT',
  SAVE_WEIGHT = 'operations/SAVE_WEIGHT',
  DELETE_WEIGHT = 'operations/DELETE_WEIGHT',
  GET_WEIGHT_UNIT = 'operations/GET_WEIGHT_UNIT',
  SET_WEIGHT_UNIT = 'operations/SET_WEIGHT_UNIT',
  SAVE_WEIGHT_UNIT = 'operations/SAVE_WEIGHT_UNIT',
  DELETE_WEIGHT_UNIT = 'operations/DELETE_WEIGHT_UNIT',
  GET_HEARING_PRECAUTIONS = 'operations/GET_HEARING_PRECAUTIONS',
  SET_HEARING_PRECAUTIONS = 'operations/SET_HEARING_PRECAUTIONS',
  SAVE_HEARING_PRECAUTIONS = 'operations/SAVE_HEARING_PRECAUTIONS',
  DELETE_HEARING_PRECAUTIONS = 'operations/DELETE_HEARING_PRECAUTIONS',
  GET_ENVIRONMENTAL_CONTROLS = 'operations/GET_ENVIRONMENTAL_CONTROLS',
  SET_ENVIRONMENTAL_CONTROLS = 'operations/SET_ENVIRONMENTAL_CONTROLS',
  SAVE_ENVIRONMENTAL_CONTROLS = 'operations/SAVE_ENVIRONMENTAL_CONTROLS',
  DELETE_ENVIRONMENTAL_CONTROLS = 'operations/DELETE_ENVIRONMENTAL_CONTROLS',
  GET_SAFETY_RESTRAINTS = 'operations/GET_SAFETY_RESTRAINTS',
  SET_SAFETY_RESTRAINTS = 'operations/SET_SAFETY_RESTRAINTS',
  SAVE_SAFETY_RESTRAINTS = 'operations/SAVE_SAFETY_RESTRAINTS',
  DELETE_SAFETY_RESTRAINTS = 'operations/DELETE_SAFETY_RESTRAINTS',
  GET_SEIZURE_PRECAUTIONS = 'operations/GET_SEIZURE_PRECAUTIONS',
  SET_SEIZURE_PRECAUTIONS = 'operations/SET_SEIZURE_PRECAUTIONS',
  SAVE_SEIZURE_PRECAUTIONS = 'operations/SAVE_SEIZURE_PRECAUTIONS',
  DELETE_SEIZURE_PRECAUTIONS = 'operations/DELETE_SEIZURE_PRECAUTIONS',
  SET_PATIENT_LOADED_COLD = 'operations/SET_PATIENT_LOADED_COLD',
  SET_PATIENT_LOADED_HOT = 'operations/SET_PATIENT_LOADED_HOT',
  SET_PATIENT_OFFLOAD_COLD = 'operations/SET_PATIENT_OFFLOAD_COLD',
  SET_PATIENT_OFFLOAD_HOT = 'operations/SET_PATIENT_OFFLOAD_HOT',
  SET_PATIENT_MONITORING = 'operations/SET_PATIENT_MONITORING',
  SET_PEDIATRIC_STRETCHER_CHAIR = 'operations/SET_PEDIATRIC_STRETCHER_CHAIR',
  SET_PEDIATRIC_SAFETY_RESTRAINT_DEVICE = 'operations/SET_PEDIATRIC_SAFETY_RESTRAINT_DEVICE',
  SET_BABYPOD = 'operations/SET_BABYPOD',
  SET_PEDIMATE = 'operations/SET_PEDIMATE',
  SET_PATIENT_PERSONAL_PROTECTIVE_EQUIPMENT = 'operations/SET_PATIENT_PERSONAL_PROTECTIVE_EQUIPMENT',
  SET_RESPONSE = 'operations/SET_RESPONSE',
  SET_RESPONSE_PNNV = 'operations/SET_RESPONSE_PNNV',
  SAVE_OPERATIONS = 'operations/SAVE_OPERATIONS',
  RESET_STATE = 'operations/RESET_STATE',
  SET_ADD_TO_TIMELINE = 'operations/SET_ADD_TO_TIMELINE',
  SET_STATE = 'operations/SET_STATE',
  SET_DATE_TIME = 'operations/SET_DATE_TIME',
  SET_ASSESSED_BY = 'operations/SET_ASSESSED_BY',
  ON_SELECT_OPERATIONS = 'operations/ON_SELECT_OPERATIONS',
  SET_UPDATE_INPUT_ROWS = 'operations/SET_UPDATE_INPUT_ROWS',
  SET_DATE = 'operations/SET_DATE',
  SET_TIME = 'operations/SET_TIME',
  SET_ATTEMPTS = 'operations/SET_ATTEMPTS',
  SET_PROCEDURE_COMPLICATIONS = 'operations/SET_PROCEDURE_COMPLICATIONS',
  SET_AUTHORIZATION = 'operations/SET_AUTHORIZATION',
  SET_SUCCESSFUL_ATTEMPT = 'operations/SET_SUCCESSFUL_ATTEMPT',
  SET_PTA = 'operations/SET_PTA',
  SET_COMMENTS = 'operations/SET_COMMENTS',
  SET_ROLE_PERFORMING = 'operations/SET_ROLE_PERFORMING',
  SET_ROLE_PERFORMING_PNNV = 'operations/SET_ROLE_PERFORMING_PNNV',
  SET_JOINT_COMMISSION_TIMEOUT_ARRAY = 'operations/SET_JOINT_COMMISSION_TIMEOUT_ARRAY',
}
